var manifestUri = '';
var connectionKey = '4DB74EA9D5CD5'
	
export const initApp = async  (response) => {
		manifestUri = await JSON.parse(Base64.decode(response).replace(/'/g, '"').replace(/\u00fc/g, "")).VURI;
   if(navigator.userAgent.match(/(iPhone|iPod|iPad)/i)) {
	  //HLS player (by hls.js) for iOS
	  var video = document.getElementById('video');
	  if(Hls.isSupported()) {
		var hls = new Hls();
		hls.loadSource(JSON.parse(Base64.decode(response).replace(/'/g, '"').replace(/\u00fc/g, "")).VURI);
		hls.attachMedia(video);
		hls.on(Hls.Events.MANIFEST_PARSED,function() {
		  video.play();
	  });
	 } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
		video.src = manifestUri;
		video.addEventListener('loadedmetadata',function() {
		  video.play();
		});
	  }
  } else {
	  //shaka player for other platforms
	  shaka.polyfill.installAll();

	  // Check to see if the browser supports the basic APIs Shaka needs.
	  if (shaka.Player.isBrowserSupported()) {
		// Everything looks good!
		  // Create a Player instance.
		  var video = document.getElementById('video');
		  var player = new shaka.Player(video);

		  // Attach player to the window to make it easy to access in the JS console.
		  window.player = player;

		  // Listen for error events.
		  player.addEventListener('error', onErrorEvent);
		  
			  player.configure({
			drm: {
				clearKeys: {
				  '60061e017e477e877e57d00d1ed00d1e': JSON.parse(Base64.decode(response).replace(/'/g, '"').replace(/\u00fc/g, "")).KEY,
				  '60061e017e477e877e57d00d1ed00d1e': JSON.parse(Base64.decode(response).replace(/'/g, '"').replace(/\u00fc/g, "")).KEY
				}
			}
		  });
		  // Try to load a manifest.
		  // This is an asynchronous process.
		  player.load(manifestUri).then(function() {
			// This runs if the asynchronous load is successful.
			console.log('The video has now been loaded!');
		  }).catch(onError);  // onError is executed if the asynchronous load fails.
	  } else {
		// This browser does not have the minimum set of APIs we need.
		console.error('Browser not supported!');
	  }
  }
}

function onErrorEvent(event) {
  // Extract the shaka.util.Error object from the event.
  onError(event.detail);
}

function onError(error) {
  // Log the error.
  console.error('Error code', error.code, 'object', error);
}

var Base64 = {characters:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",encode:function(a){Base64.characters;var r="",e=0;do{var c=a.charCodeAt(e++),t=a.charCodeAt(e++),h=a.charCodeAt(e++),s=(c=c||0)>>2&63,n=(3&c)<<4|(t=t||0)>>4&15,d=(15&t)<<2|(h=h||0)>>6&3,o=63&h;t?h||(o=64):d=o=64,r+=Base64.characters.charAt(s)+Base64.characters.charAt(n)+Base64.characters.charAt(d)+Base64.characters.charAt(o)}while(e<a.length);return r},decode:function(a){Base64.characters;var r="",e=0;do{var c=Base64.characters.indexOf(a.charAt(e++)),t=Base64.characters.indexOf(a.charAt(e++)),h=Base64.characters.indexOf(a.charAt(e++)),s=(63&c)<<2|t>>4&3,n=(15&t)<<4|h>>2&15,d=(3&h)<<6|63&Base64.characters.indexOf(a.charAt(e++));r+=String.fromCharCode(s)+(n?String.fromCharCode(n):"")+(d?String.fromCharCode(d):"")}while(e<a.length);return r}};

// document.addEventListener('DOMContentLoaded', initApp);



// WEBPACK FOOTER //
// ./src/assets/js/enc_player/code.js